/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
        } else {
            navigation.classList.remove('is-open');
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Add lightbox to gallery images */
(function () {
    var gh_header_left = document.querySelector(".gh-header-left")
    if (gh_header_left == null) {
        return;
    }
    var leftHeight = gh_header_left.clientHeight;
    document.querySelectorAll(".gh-header-middle, .gh-header-right").forEach(function (element) {
        element.style.height = leftHeight + "px";
    });
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
// (function () {
//     if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
//         pagination(false);
//     }
// })();

(function () {
    const filters = document.querySelectorAll('.tag-filter li');
    const elements = document.querySelectorAll('.gh-main .gh-feed article');
    filters.forEach(filter => {
        filter.addEventListener('click', function () {
            const dataValue = filter.getAttribute('data-tag');
            if(dataValue == "tag-all") {
                elements.forEach(element =>{
                    element.classList.remove("hide")
                    element.classList.add("show")
                })
            } else {
                elements.forEach(element =>{
                    element.classList.remove("show")
                    element.classList.add("hide")
                })
               
                const availableElement = document.querySelectorAll('article.' + dataValue)
                availableElement.forEach(element => {
                    element.classList.remove("hide")
                    element.classList.add("show")
                })
            }
            filters.forEach(filter => {
                filter.classList.remove("active");
            })

            const activeTag = document.querySelector('.' + dataValue)
            activeTag.classList.add("active")
        });
    });
    // const burger = navigation.querySelector('.gh-burger');
    // if (!burger) return;

    // burger.addEventListener('click', function () {
    //     if (!navigation.classList.contains('is-open')) {
    //         navigation.classList.add('is-open');
    //     } else {
    //         navigation.classList.remove('is-open');
    //     }
    // });
})();